import React from 'react';
import PhoneCarousel from '../../components/PhoneCarousel';
import {
  LandingContainer,
  Hero,
  HeroContent,
  Heading,
  Subheading,
  AppStoreBadge,
  FeaturesSection,
  FeatureGrid,
  Feature,
  FeatureIcon,
  FeatureTitle,
  FeatureDescription,
  PhoneDisplay,
  DownloadSection,
  DownloadContent,
  DownloadText,
} from './styles';

const Landing: React.FC = () => {
  return (
    <LandingContainer>
      <Hero>
        <HeroContent>
          <Heading>Find the Perfect Gift Idea</Heading>
          <Subheading>
            PrezziePal helps you remember birthdays, create wishlists, and find
            the perfect gifts for your friends.
          </Subheading>

          <AppStoreBadge
            href="https://apps.apple.com/us/app/prezziepal/id6742743048"
            target="_blank"
          >
            <img src="/app-store-badge.svg" alt="Download on the App Store" />
          </AppStoreBadge>
        </HeroContent>
        <PhoneDisplay>
          <PhoneCarousel />
        </PhoneDisplay>
      </Hero>

      <FeaturesSection>
        <Heading>Make Gifting Effortless</Heading>
        <FeatureGrid>
          <Feature>
            <FeatureIcon>🤖</FeatureIcon>
            <FeatureTitle>AI Gift Recommendations</FeatureTitle>
            <FeatureDescription>
              Get AI-powered gift suggestions for your wishlist and smart
              recommendations for pals based on their interests
            </FeatureDescription>
          </Feature>
          <Feature>
            <FeatureIcon>🎂</FeatureIcon>
            <FeatureTitle>Birthday Reminders</FeatureTitle>
            <FeatureDescription>
              Never forget important birthdays with our intelligent reminder
              system
            </FeatureDescription>
          </Feature>
          <Feature>
            <FeatureIcon>🎁</FeatureIcon>
            <FeatureTitle>Wishlist Management</FeatureTitle>
            <FeatureDescription>
              Create and share wishlists with your friends and family
            </FeatureDescription>
          </Feature>
          <Feature>
            <FeatureIcon>📱</FeatureIcon>
            <FeatureTitle>Contact Sync</FeatureTitle>
            <FeatureDescription>
              Easily import birthdays from your contact list
            </FeatureDescription>
          </Feature>
        </FeatureGrid>
      </FeaturesSection>

      <DownloadSection>
        <DownloadContent>
          <DownloadText>
            <Heading>Download PrezziePal</Heading>
            <AppStoreBadge
              href="https://apps.apple.com/us/app/prezziepal/id6742743048"
              target="_blank"
            >
              <img src="/app-store-badge.svg" alt="Download on the App Store" />
            </AppStoreBadge>
          </DownloadText>
        </DownloadContent>
      </DownloadSection>
    </LandingContainer>
  );
};

export default Landing;
